import { gql } from '@apollo/client'

export const REQUEST_PAYMENT_MUTATION = gql`
  mutation requestPayment($paymentId: ID!) {
    requestPayment(paymentId: $paymentId) {
      stripeCheckoutUrl
    }
  }
`
